<div
    [ngStyle]="{
    'width.px': size,
    'height.px': size,
    'max-height.px': size,
    'background-image': imageUrl
  }"
    class="photo rounded-circle"
    [class.editable]="editable"
>
    @if (editable) {
        <i class="edit-icon dx-icon-photooutline"></i>
    }
</div>
@if (editable) {
    <dx-file-uploader
        [dialogTrigger]="hostRef"
        [visible]="false"
        [uploadUrl]="uploadUrl"
        accept="image/*"
        uploadMode="instantly"
        (onUploaded)="onUploaded($event)"
    ></dx-file-uploader>
}
